import { z } from 'zod'
import { TicketValidityPeriod } from '~library/enums'
import {
  managerBenefitFileSchema,
  managerBenefitCommonSchema,
  dateValueSchema,
  enumWithEmpty
} from '~library/models'
import { fileDescriptionSchema } from './file-description'

export const managerBenefitGetDetailSchema = z.object({
  /** 熱門 */
  popular: z.boolean(),
  /** 限時 */
  flashSale: z.boolean(),
  /** 限量 */
  limitedEdition: z.boolean(),
  /** 售罄 */
  soldOut: z.boolean(),
  /** 原始點數 */
  originalPoint: z.number(),
  /** 點數 */
  point: z.number(),
  /** 用效期[天] */
  validityPeriod: enumWithEmpty(TicketValidityPeriod),
  /** 檔案 */
  file: z.array(managerBenefitFileSchema),
  /** 購物車數量 */
  shoppingCartQuantity: z.number(),
  /** 庫存數量 */
  quantity: z.number(),
  /** 使用起始時間 */
  useStartTime: dateValueSchema,
  /** 使用截止時間 */
  useEndTime: dateValueSchema,
  ...managerBenefitCommonSchema.shape,
  ...fileDescriptionSchema.shape
})

export interface ManagerBenefitGetDetail extends z.infer<
  typeof managerBenefitGetDetailSchema
> {}
